import { module as Module } from 'modujs';

export default class Filter extends Module {
    static DROPDOWN_ACTIVE_CLASS = 'has-dropdown-active';
    static DROPDOWN_OPEN_CLASS = 'has-dropdown-open';

    constructor(m) {
        super(m);

        // Binding
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleKeyboardNavigation = this.handleKeyboardNavigation.bind(this);

        // UI
        this.$filtersList = this.$('filterList')[0];
        this.$items = Array.from(this.$('item'));
        this.$dropdownTogglers = this.$('dropdownToggler');
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        this.$dropdownTogglers.forEach(($toggler) => {
            $toggler.addEventListener('click', this.toggleDropdown);
            $toggler.addEventListener('keydown', this.handleKeyboardNavigation);
        });

        this.scrollToActiveItem();
    }

    destroy() {
        super.destroy();

        // Remove event listeners when destroying
        this.$dropdownTogglers.forEach(($toggler) => {
            $toggler.removeEventListener('click', this.toggleDropdown);
            $toggler.removeEventListener('keydown', this.handleKeyboardNavigation);
        });
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    toggleDropdown(event) {
        const $toggler = event.currentTarget;
        const $parentLi = $toggler.closest('li');
        const $dropdown = $parentLi.querySelector('.c-filter_dropdown');
        this.$filtersList.classList.remove(Filter.DROPDOWN_OPEN_CLASS);

        if ($parentLi.classList.contains(Filter.DROPDOWN_ACTIVE_CLASS)) {
            // Dropdown is already open, close it
            $parentLi.classList.remove(Filter.DROPDOWN_ACTIVE_CLASS);
            $toggler.setAttribute('aria-expanded', 'false');
            $dropdown.setAttribute('aria-hidden', 'true');
        } else {
            // Close other dropdowns
            this.closeAllDropdowns();

            this.$filtersList.classList.add(Filter.DROPDOWN_OPEN_CLASS);

            // Open the clicked dropdown
            $parentLi.classList.add(Filter.DROPDOWN_ACTIVE_CLASS);
            $toggler.setAttribute('aria-expanded', 'true');
            $dropdown.setAttribute('aria-hidden', 'false');

            // Focus on the first link in the dropdown for accessibility
            const firstLink = $parentLi.querySelector('.c-filter_dropdown a');
            if (firstLink) firstLink.focus();
        }

        event.preventDefault();
    }

    handleKeyboardNavigation(event) {
        const $toggler = event.currentTarget;
        const $parentLi = $toggler.closest('li');

        // If Enter or Space is pressed, simulate a click to toggle the dropdown
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleDropdown(event, $toggler);
        }

        // If Esc is pressed, close the dropdown
        if (event.key === 'Escape' && $parentLi.classList.contains(Filter.DROPDOWN_ACTIVE_CLASS)) {
            $parentLi.classList.remove(Filter.DROPDOWN_ACTIVE_CLASS);
            $toggler.setAttribute('aria-expanded', 'false');
            const $dropdown = $parentLi.querySelector('.c-filter_dropdown');
            $dropdown.setAttribute('aria-hidden', 'true');
            $toggler.focus(); // Return focus to the toggler for accessibility
        }
    }

    // =============================================================================
    // Methods
    // =============================================================================
    closeAllDropdowns() {
        // Remove the active class and update ARIA attributes from all parent <li> elements
        this.$dropdownTogglers.forEach(($toggler) => {
            const $parentLi = $toggler.closest('li');
            const $dropdown = $parentLi.querySelector('.c-filter_dropdown');

            if ($parentLi.classList.contains(Filter.DROPDOWN_ACTIVE_CLASS)) {
                $parentLi.classList.remove(Filter.DROPDOWN_ACTIVE_CLASS);
                $toggler.setAttribute('aria-expanded', 'false');
                $dropdown.setAttribute('aria-hidden', 'true');
            }
        });
    }

    scrollToActiveItem() {
        let cumulativeOffset = 0;
        this.metrics = this.$items.map(($link) => {
            cumulativeOffset = cumulativeOffset + $link.offsetWidth;
            return cumulativeOffset;
        });
        const findIndex = this.$items.findIndex(($item) => $item.classList.contains('is-active'));

        this.$filtersList.scrollTo({
            left: this.metrics[findIndex - 1] || 0
        });
    }
}
